import anime from 'animejs';

import {
  BEBOT_ROLLOUT_CONTAINER,
  BEBOT_ROLLOUT_CIRCLE,
  BEBOT_ROLLOUT_TEXT,
  BEBOT_FIRST_MESSAGE_BADGE,
  BEBOT_ROLLOUT_CLOSE_BUTTON,
} from '../widgetClassNames';

const getRolloutContainer = () => document.querySelector(`.${BEBOT_ROLLOUT_CONTAINER}`);
const getRolloutCircles = () => document.querySelectorAll(`.${BEBOT_ROLLOUT_CIRCLE}`);
const getRolloutText = () => document.querySelector(`.${BEBOT_ROLLOUT_TEXT}`);
const getFirstMessageBadge = () => document.querySelector(`.${BEBOT_FIRST_MESSAGE_BADGE}`);
const getRolloutCloseButton = () => document.querySelector(`.${BEBOT_ROLLOUT_CLOSE_BUTTON}`);

function messageNotificationCircleAnimation() {
  const tl = anime.timeline({
    easing: 'easeOutExpo',
    delay(el, i) {
      return i * 100;
    },
    loop: true,
  });
  tl.add({
    targets: getRolloutCircles(),
    duration: 400,
    opacity: 1,
  });
  tl.add({
    targets: getRolloutCircles(),
    duration: 400,
    opacity: 0.3,
  });
}

function cleanUpNotificationBeforeExpand() {
  const circles = getRolloutCircles();
  anime.remove(circles);
  [].forEach.call(circles, elem => elem.remove());
}

function messageNotificationExpandAnimation({ width = 380, instant = false }) {
  cleanUpNotificationBeforeExpand();
  anime({
    targets: getRolloutContainer(),
    width,
    height: '50px',
    bottom: '14px',
    duration: instant ? 0 : 600,
    easing: 'easeOutExpo',
  });
  const rolloutText = getRolloutText();
  if (rolloutText) rolloutText.style.display = 'flex';
  anime({
    targets: getRolloutText(),
    opacity: 1,
    duration: instant ? 0 : 2000,
    delay: 300,
  });
  const firstMessageBadge = getFirstMessageBadge();
  if (firstMessageBadge) firstMessageBadge.style.display = 'flex';
  anime({
    targets: getFirstMessageBadge(),
    opacity: 1,
    translateY: 5,
  });
  anime({
    targets: getRolloutCloseButton(),
    opacity: 1,
    delay: instant ? 0 : 300,
  });
}

export function rolloutAnimation({ align, width, instant = false }) {
  anime({
    targets: getRolloutContainer(),
    opacity: 1,
    translateX: align === 'left' ? -20 : 20,
    duration: 500,
    easing: 'easeOutExpo',
    delay: instant ? 0 : 2000,
    complete: () => {
      if (!instant) messageNotificationCircleAnimation();
      setTimeout(
        () => {
          messageNotificationExpandAnimation({ width, instant });
        },
        instant ? 0 : 2000
      );
    },
  });
}

export function closeRolloutAnimation({ align, removeRollout }) {
  anime({
    targets: getFirstMessageBadge(),
    opacity: 0,
    duration: 200,
    translateY: 5,
    easing: 'linear',
  });
  anime({
    targets: getRolloutContainer(),
    translateX: align === 'left' ? 20 : -20,
    opacity: 0,
    duration: 300,
    easing: 'linear',
    complete: () => {
      removeRollout();
    },
  });
}

export function adjustRolloutAfterResize({ align, width }) {
  rolloutAnimation({ align, width, instant: true });
}
